.container {
    position: relative;
    height: 100px;
    width: 100%;
    overflow: hidden;
}

.container-short {
    height: 90px;
}

.container-tall {
    height: 120px;
}

.container:hover [data-zoom-level='2'],
.state-superzoom [data-zoom-level='3'],
.container [data-zoom-level='1'] {
    opacity: 1;
}

.map-link {
    position: absolute;
    inset: 0;
    z-index: 3;
    display: block;
}

.map-zoom-target {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 80px;
    height: 50px;
    transform: translate(-50%, -50%);
}

.weather {
    position: absolute;
    height: fit-content;
    top: 16px;
    right: 16px;
    bottom: 16px;
    min-width: 240px;
    max-width: 320px;
    z-index: 4;
}

.container [data-empty-state='true'] {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: flex-end;
    justify-content: center;
}

.container [data-empty-state='true'] img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    display: block;
}
